import { Action, Dispatch } from "redux";
import { notification } from "antd";
import { Key } from "react";
import moment from "moment";
import { AxiosError, AxiosResponse } from "axios";

import {
  GET_INSURANCES,
  GET_INSURANCE_BY_ID,
  SET_INSURANCE_TO_NULL,
} from "./types";
import { ApiService } from "../../../services";
import {
  NavigationPath,
  mapDataRows,
  history,
  showErrorNotification,
} from "../../../utils";
import { addEditValuesType } from "../../../models";

export const addInsurance =
  (insurance: addEditValuesType) => async (dispatch: Dispatch<Action>) => {
    ApiService.post("/insurance", insurance)
      .then((res: AxiosResponse) => {
        if (res.status !== 201) {
          showErrorNotification(
            "Dodavanje osiguravajućeg društva nije uspjelo"
          );
          return;
        }

        notification.success({
          message: "Osiguravajuće društvo je dodano.",
        });
        history.navigate(NavigationPath.INSURANCE_ROUTE);
      })
      .catch((err: AxiosError) => {
        showErrorNotification(
          "Dodavanje osiguravajućeg društva nije uspjelo",
          err
        );
      });
  };

export const getInsurances = () => async (dispatch: Dispatch<Action>) => {
  ApiService.get("/insurance")
    .then((res: AxiosResponse) => {
      const { status, data } = res;
      if (status !== 200) {
        showErrorNotification(
          "Učitavanje osiguravajućih društava nije uspjelo"
        );
        return;
      }

      const insurances = mapDataRows(data.rows);

      dispatch({
        type: GET_INSURANCES,
        payload: insurances,
      });
    })
    .catch((err: AxiosError) => {
      showErrorNotification(
        "Učitavanje osiguravajućih društava nije uspjelo",
        err
      );
    });
};

export const deleteInsurance =
  (ids: Key[]) => async (dispatch: Dispatch<Action>) => {
    ApiService.delete(`insurance/`, {
      data: { ids },
    })
      .then((res: AxiosResponse) => {
        const { status } = res;

        if (status !== 204) {
          showErrorNotification("Brisanje osiguravajućeg društva nije uspjelo");
          return;
        }
        notification.success({
          message:
            ids.length === 1
              ? "Osiguravajuće društvo je obrisano."
              : "Osiguravajuća društva su obrisana.",
        });
        getInsurances()(dispatch);
      })
      .catch((err: AxiosError) => {
        showErrorNotification(
          "Brisanje osiguravajućeg društva nije uspjelo",
          err
        );
      });
  };

export const updateInsurance =
  (insuranceToEdit: addEditValuesType, id: Key) =>
  async (dispatch: Dispatch<Action>) => {
    ApiService.put(`insurance/${id}`, insuranceToEdit)
      .then((res: AxiosResponse) => {
        const { status } = res;

        if (status !== 200) {
          showErrorNotification("Izmjena osiguravajućeg društva nije uspjela");
          return;
        }

        notification.success({
          message: "Izmjene su sačuvane.",
        });
        history.navigate(NavigationPath.INSURANCE_ROUTE);
      })
      .catch((err: AxiosError) => {
        showErrorNotification(
          "Izmjena osiguravajućeg društva nije uspjela",
          err
        );
      });
  };

export const getInsuranceById =
  (id: Key) => async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: SET_INSURANCE_TO_NULL,
    });
    ApiService.get(`insurance/${id}`)
      .then((res: AxiosResponse) => {
        const { status, data } = res;

        if (status !== 200) {
          showErrorNotification(
            "Učitavanje osiguravajućeg društva nije uspjelo"
          );
          return;
        }

        dispatch({
          type: GET_INSURANCE_BY_ID,
          payload: data,
        });
      })
      .catch((err: AxiosError) => {
        showErrorNotification(
          "Učitavanje osiguravajućeg društva nije uspjelo",
          err
        );
      });
  };
